// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
import _ from 'underscore';

const ADMIN = 0;
const MEMBER = 1;

export default {
  ADMIN,
  MEMBER,

  NO_PERMISSION: Infinity,
  PERMISSION_LEVEL_TO_DISPLAY: _.object([
    [ADMIN, 'Admin'],
    [MEMBER, 'Member'],
  ]),
};
